import styled from 'styled-components';

const LayoutContainer = styled.div`
  margin: 0 auto;
  max-width: 1300px;
  width: 100%;
  padding: 2rem 4rem 0;
  min-height: calc(100vh - 60px - 110px);
  display: flex;
  flex-direction: column;

  padding-top: 5rem; // Sabit üst padding

  @media (max-width: 1200px) {
    padding: 5rem 2.5rem 0;
  }
  @media (max-width: 992px) {
    padding: 5rem 1.25rem 0;
  }
  @media (max-width: 768px) {
    padding: 5rem 1rem 0;
  }
  @media (max-width: 576px) {
    padding: 5rem 0.75rem 0;
  }
`;

type Props = {
  children: React.ReactNode;
};

export const MainLayout = ({ children }: Props) => {
  return <LayoutContainer>{children}</LayoutContainer>;
};